module.exports = ".mat-form-field{width:100%}.mat-form-field input.mat-chip-input{width:10rem;flex:1 0 10rem}\n"